<script setup>
import { computed } from "vue";
import { Tippy } from "vue-tippy";

const props = defineProps({
    content: {
        type: String,
    },
    placement: {
        type: String,
        default: "top",
    },
});

const html = computed(() => {
    return "<div class='border-white/10 px-3 py-2 text-gray-200 bg-gray-900 rounded-md border shadow-sm'>" + props.content + "</div>";
});
</script>

<template>
    <component
        :is="content !== undefined && content.length > 0 ? Tippy : 'div'"
        :content="html"
        animation="scale"
        :duration="100"
        :hideOnClick="false"
        :placement="placement">
        <slot></slot>
    </component>
</template>
